export const CANT_FIND_BUSINESS_TITLE = "Can't find your business?";

export const BUSINESS_SEARCH_LABEL = 'Business Name';
export const BUSINESS_SEARCH_PLACEHOLDER = 'Enter business name';
